import React, { type ReactElement, useState } from 'react';
import { faPersonRunning } from '@fortawesome/free-solid-svg-icons';
import TableActions from 'atom-components/table-actions-lite';
import ChangeActiveMarkerModal from 'pages/marking/subpages/marks-for-review-tab/change-active-marker-modal';
import type { TestInstanceResponseMarkWithActiveMarkerAndResponse } from 'services/assist-api/entities/test-instance-response-mark/types';

type Props = {
  mark: TestInstanceResponseMarkWithActiveMarkerAndResponse;
};

export default function ChangeActiveMarkerButton({ mark }: Props): ReactElement {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      {isModalOpen && (
        <ChangeActiveMarkerModal
          isOpen={isModalOpen}
          onClose={(): void => setIsModalOpen(false)}
          mark={mark}
        />
      )}
      <TableActions.Button
        tooltip="Change Active Marker"
        onClick={(): void => setIsModalOpen(true)}
        icon={faPersonRunning}
      />
    </>
  );
}
